/**
 * Static team roster — display copy lives in i18n (`meetTheTeam.members.*`).
 */
export const TEAM_MEMBERS = [
  {
    id: 'maverick',
    linkedin: 'https://www.linkedin.com/in/maverick0329/',
    image: '/asset/images/team/Maverick.jpeg',
    accentColor: '#185FA5',
  },
  {
    id: 'niki',
    linkedin: 'https://www.linkedin.com/in/niki-yeung02706/',
    image: '/asset/images/team/Niki.jpeg',
    accentColor: '#1D6F42',
  },
  {
    id: 'carson',
    linkedin: 'https://www.linkedin.com/in/chingwingchun/',
    image: '/asset/images/team/Carson.jpeg',
    accentColor: '#9333EA',
  },
  {
    id: 'hin',
    linkedin: 'https://www.linkedin.com/in/y-h-n-008423285/',
    image: '/asset/images/team/Hin.jpeg',
    accentColor: '#B45309',
  },
  {
    id: 'cole',
    linkedin: 'https://www.linkedin.com/in/cole-yu-wong/',
    image: '/asset/images/team/Cole.jpeg',
    accentColor: '#BE123C',
  },
];
